// Undo functionality
jQuery(function( $ ) {
    "use strict"

    // Uses theme/vendor/js-undo-manager

    // strut for browsers without the capability
    if ( ! ( 'bind' in Function.prototype ) ) {
        Function.prototype.bind = function() {
            var fn = this;
            var context = arguments[0];
            var args = Array.prototype.slice.call( arguments, 1 );
            return function() {
                return fn.apply( context, args.concat( [].slice.call( arguments ) ) );
            }
        }
    }

    // Creates undo/redo stack
    window.undoManager = new UndoManager(); // theme/vendor/js-undo-manager
    // Set callback that adjusts button state after redo/undo actions
    window.undoManager.setCallback( updateUndoButtons );
    // Adding variables to the undoManager object that can be used to check if we are undoing or redoing
    window.undoManager.undoing = false;
    window.undoManager.redoing = false;


    // Event Handlers for undo/redo buttons

    $( document ).on( 'click', '.undo-link', function(e) {
        e.preventDefault();
        window.undoManager.undoing = true;
        window.undoManager.undo();
    });

    $( document ).on( 'click', '.redo-link', function(e) {
        e.preventDefault();
        window.undoManager.redoing = true;
        window.undoManager.redo();
    });

    // Toggles button disabled state based on undoManager stack
    function updateUndoButtons() {
        $( '.undo-link' ).toggleClass( 'disabled', ! window.undoManager.hasUndo() );
        $( '.redo-link' ).toggleClass( 'disabled', ! window.undoManager.hasRedo() );
    }

});
